import React from 'react'
import Layout from '../../components/layout'
import RichContent from '../../uielements/RichContent/richContent'
import PageHeader from '../../components/PageHeader'
import { Box, Flex, Heading } from '@chakra-ui/react'
import CustomImage from '../../uielements/Image'
import Attachments from '../commonSections/attachments'
import PageGallery from '../commonSections/gallery'
import PageAccordion from '../commonSections/accordion'
import RelatedPosts from '../../sections/RelatedPosts'
import { ContainerXl } from '../../components/Containers/containers'
import GoogleMapComponent from '../../components/GoogleMapComponent'

const PageLeftFeatImage = ({ context, page }) => {
    return (
        <Layout>
            <PageHeader title={page?.title} subtitle={page?.subtitle} featImg={page?.featuredImage} />
            <Box py={[2,2,4,8, 16]} px={[2, 2, 4, 12, 36]}>
                <Flex direction={{ base: 'column-reverse', lg: 'row' }} gap={'20px'}>
                    <Box flexBasis={{ base: '100%', lg: '35%' }}>
                        {page?.featuredImage && (
                            <Box borderRadius={28}>
                                <CustomImage obj={page.featuredImage} borderRadius={28} fit={'contain'} />
                            </Box>
                        )}
                    </Box>
                    <Box flexBasis={{ base: '100%', lg: '65%' }}>
                        <RichContent body={page.body} locale={page?.node_locale} />
                    </Box>
                </Flex>
            </Box>
            {
                context.slug === 'epikoinonia' &&
                <Box>
                    <ContainerXl>
                        <Heading as={'h2'} mb={10}>
                            GOOGLE MAPS
                        </Heading>
                    </ContainerXl>
                    <GoogleMapComponent />
                </Box>
            }
            <PageAccordion page={page} />
            <RelatedPosts blogCategory={page?.blogCategory} blogTags={page?.blogTags} />
            <Attachments attachments={page?.attachments} />
            <PageGallery gallery={page?.gallery} />
        </Layout>
    )
}

export default PageLeftFeatImage
